import { WNIAds } from '@weathernews/btos-javascript-modules/src/ads/index.js'

export default defineNuxtPlugin((nuxtApp) => {
  const ads = new WNIAds({ loadPrebids: true })
  nuxtApp.provide('ads', ads)
})
